import { GlobeIcon, PhoneIcon } from 'lucide-react';
import { dealerContact } from '@/state/config.js';

/** Appended when a flow dead-ends; both config fields are nullable. */
export function DeadEndAttachment() {
  const { phone, websiteUrl } = dealerContact.value;

  if (!phone && !websiteUrl) {
    return (
      <div className="sm-panel sm-animate-in sm-chat-tail sm-stack sm-chat-attachment">
        <p className="sm-type-eyebrow">Reach your dealer</p>
        <p className="sm-type-body sm-muted">
          Get in touch with the dealership you purchased from and they&apos;ll take it from here.
        </p>
      </div>
    );
  }

  return (
    <div className="sm-panel sm-animate-in sm-chat-tail sm-stack sm-chat-attachment">
      <p className="sm-type-eyebrow">Reach your dealer</p>
      {phone ? (
        <a className="sm-type-body sm-chat-attachment-row" href={`tel:${phone}`}>
          <span className="sm-center sm-chat-attachment-icon">
            <PhoneIcon size={16} aria-hidden="true" />
          </span>
          <span>{phone}</span>
        </a>
      ) : null}
      {websiteUrl ? (
        <a
          className="sm-type-body sm-chat-attachment-row"
          href={websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sm-center sm-chat-attachment-icon">
            <GlobeIcon size={16} aria-hidden="true" />
          </span>
          <span>Visit website</span>
        </a>
      ) : null}
    </div>
  );
}
